import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取购买权限
 * @param data
 */
export function getPurchaseList(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Right/List/Page`,
    method: 'post',
    headers: {
      'Ykt-ViewState': viewState
    },
    data
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}

/**
 * 获取购买权限
 * @param data
 */
export function getViewHistory(data, viewState) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/ViewHistory/List`,
    method: 'post',
    headers: {
      'Ykt-ViewState': viewState
    },
    data
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}

/**
 * 提交用户反馈
 * @param data
 */
export function setFeedback(data) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Account/Feedback/Create`,
    method: 'post',

    data
  })
    .then(data => {
      return data
    })
    .catch(() => null)
}
